import {useSelector} from 'react-redux';

/**
 * The current employee record for the logged-in user.
 * @returns {Object} The current employee.
 */
export const useEmployee = () => useSelector(state => state.user.employee);
